import {ActivitiesSectorSettings} from '../backend/interfaces/activities-sector-settings';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class EntityActivityTypesSettingsRepository {
  // Singleton Instance
  private static _instance: EntityActivityTypesSettingsRepository;

  // Private
  private logger: Logger;

  static get instance(): EntityActivityTypesSettingsRepository {
    if (!this._instance) {
      this._instance = new EntityActivityTypesSettingsRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('EntityActivityTypesSettingsRepository');
  }

  public async getEntityActivitiesSectorSettings(
    entityId: string,
    activitiesSectorId: string
  ): Promise<ActivitiesSectorSettings> {
    // Set url
    const url: string = `/entities/${entityId}/activities/sectors/${activitiesSectorId}/settings?localize=true`;

    // Get Activities Sector settings from backend
    const response = await BackendApiManager.instance.get<ActivitiesSectorSettings>(url);

    // Return
    return response.data;
  }
}
